import LenovoIdeaPadV14G3 from "../assets/lenovo/LenovoIdeapadV14G3.jpg";

const lenovoProducts = [
  {
    id: 1,
    name: "Lenovo Ideapad V14 G3",
    image: LenovoIdeaPadV14G3,
    specs: [
      "Intel i7-1255U processor",
      "16GB DDR4 3200 Mhz",
      "512GB SSD Nvme",
      "14 FHD 180 degree",
      "Integrated Iris 8GB GPU",
      "Windows 11 Pro",
    ],
    price: "₹62,999",
    whatsappText: "Hi, I am interested in Lenovo Ideapad V14 G3",
  },
];

export default lenovoProducts;
